import { render, staticRenderFns } from "./ImportReview.vue?vue&type=template&id=ac02c340&"
import script from "./ImportReview.vue?vue&type=script&lang=js&"
export * from "./ImportReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports